import { IsBoolean } from 'class-validator';

export class SettingsServiceFunctionsDto {
  @IsBoolean()
  createPayOrdersFromPurchases: boolean;
}
